import { AccountTab } from '../Account';
import { LiveTab } from '../MyStreamsSection';

export const MY_VIDEOS_TAB = 0;
export const MY_STREAMS_TAB = 1;
export const MY_UPLOADS_TAB = 2;
export const VIDEO_TEMPLATES_TAB = 3;
export const ACCOUNT_TAB = 4;
export const SUBSCRIPTION = 5;

export type TAB =
  | typeof MY_VIDEOS_TAB
  | typeof MY_STREAMS_TAB
  | typeof MY_UPLOADS_TAB
  | typeof VIDEO_TEMPLATES_TAB
  | typeof ACCOUNT_TAB
  | typeof SUBSCRIPTION;

export type TabType = LiveTab | AccountTab;

export type MyProjectSectionProps = {
  activeTab: TAB;
  isSemrush?: boolean;
  currentTab?: TabType;
  hideMobileNavigationDropdown?: boolean;
  onTabChange?(tab: TAB): void;
};

export type ProjectTabsProps = {
  activeTab?: TAB;
  isSemrush?: boolean 
  currentTab?: TabType;
  canLiveStream?: boolean;
  fetchStreams(): void;
  fetchUploads(): void;
  fetchRootFolder(): void;
  onTabChange?(tab: TAB): void;
};
